import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/confirm_account_notice/$')({
  // Migrated from the Ember `confirm_account_notice` route. The dedicated
  // "confirm your account" page is gone — confirmation is now a persistent
  // in-app alert — so this just redirects. The index route (`/`) already
  // implements the same landing logic the Ember route did: send the user to
  // their default workspace dashboard, or to settings when they have none.
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
